import React, { useState } from 'react';
import Api from '../../api/global.service';
import { Link } from 'react-router-dom';
import LinkDownloadSpinner from './link-download-spinner.jsx';

const RELOAD_TIME = 15000; // 15segs

const LinkDownload = ({ url, label, icon, color = '#789D16', isZip = false, finalFunction = () => {} }) => {

  const [blocking, setBlocking] = useState(false);
  const handleDownload = (event) => {
    event.preventDefault();
    setBlocking(true)
    Api.download(url)
      .then(response => {
        // no file returned, refresh the page since backend need more time
        if (response.data.size === 0) {
          setTimeout(() => window.location.reload(), RELOAD_TIME);
          return false;
        }

        let fileName;
        let url;
        if (isZip) {
          fileName = response.headers['content-disposition'].split(`'`)[2];
          url = window.URL.createObjectURL(new Blob([response.data], { type: 'octet/stream' }));
        } else {
          fileName = response.headers['content-disposition'].split('filename=')[1];
          url = window.URL.createObjectURL(new Blob([response.data])); // you can mention a type if you wish
        }
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); //this is the name with which the file will be downloaded
        link.click();
        // no need to append link as child to body.
        setTimeout(() => window.URL.revokeObjectURL(url), 0); // this is important too, otherwise we will be unnecessarily spiking memory!

      })
      .catch(e => {
        console.log('error', e)
      })
      .finally(() => {
        finalFunction();
        setBlocking(false);
      });
  }

    return (
      <>
        {blocking && (
          <LinkDownloadSpinner />
        )}

        {!blocking && (
          <Link to="#" onClick={e => handleDownload(e)} className="m-r-2" style={{ color: color }}>
            <img src={icon} className="pr-1" /> <span>{label}</span>
          </Link>
        )}
      </>
    );
}

export default LinkDownload;
